import axios from "axios"
import { startSubmit, stopSubmit, reset, SubmissionError } from "redux-form"
// SHARED
import { docCookies } from "../utils/docCookies"
import { ApiHelper, axiosInstance } from "../utils/ApiHelper"

export const SHOW_CREATE_SUBSCRIPTION_MODAL = "SHOW_CREATE_SUBSCRIPTION_MODAL"
export const HIDE_CREATE_SUBSCRIPTION_MODAL = "HIDE_CREATE_SUBSCRIPTION_MODAL"
export function hideCreateSubscriptionSuccessModal() {
  return {
    type: HIDE_CREATE_SUBSCRIPTION_MODAL
  }
}

export const POTENTIAL_CREDITS_SUCCESS = "POTENTIAL_CREDITS_SUCCESS"
export function potentialCreditsSuccess(json) {
  return {
    type: POTENTIAL_CREDITS_SUCCESS,
    potentialCredits: json.potential_credits
  }
}

export const CANCEL_REACTIVATE_SUBSCRIPTION_FORM_REQUEST =
  "CANCEL_REACTIVATE_SUBSCRIPTION_FORM_REQUEST"
export const CANCEL_REACTIVATE_SUBSCRIPTION_FORM_FAILURE =
  "CANCEL_REACTIVATE_SUBSCRIPTION_FORM_FAILURE"
export const CANCEL_REACTIVATE_SUBSCRIPTION_FORM_SUCCESS =
  "CANCEL_REACTIVATE_SUBSCRIPTION_FORM_SUCCESS"
export const CANCEL_REACTIVATE_SUBSCRIPTION_FORM_RESET =
  "CANCEL_REACTIVATE_SUBSCRIPTION_FORM_RESET"
export function cancelReactivateSubscriptionFormRequest() {
  return {
    type: CANCEL_REACTIVATE_SUBSCRIPTION_FORM_REQUEST
  }
}
function cancelReactivateSubscriptionFormFailure(json) {
  return {
    type: CANCEL_REACTIVATE_SUBSCRIPTION_FORM_FAILURE,
    json: json
  }
}
function cancelReactivateSubscriptionFormSuccess() {
  return {
    type: CANCEL_REACTIVATE_SUBSCRIPTION_FORM_SUCCESS
  }
}
export function cancelReactivateSubscriptionFormReset() {
  return {
    type: CANCEL_REACTIVATE_SUBSCRIPTION_FORM_RESET
  }
}

export const REACTIVATE_SUBSCRIPTION_REQUEST = "REACTIVATE_SUBSCRIPTION_REQUEST"
export const REACTIVATE_SUBSCRIPTION_SUCCESS = "REACTIVATE_SUBSCRIPTION_SUCCESS"
export const REACTIVATE_SUBSCRIPTION_FAILURE = "REACTIVATE_SUBSCRIPTION_FAILURE"
export function reactivateSubscriptionRequest() {
  return {
    type: REACTIVATE_SUBSCRIPTION_REQUEST
  }
}
function reactivateSubscriptionSuccess(json) {
  return {
    type: REACTIVATE_SUBSCRIPTION_SUCCESS,
    subscription: json.subscription,
    receivedAt: Date.now()
  }
}
function reactivateSubscriptionFailure() {
  return {
    type: REACTIVATE_SUBSCRIPTION_FAILURE,
    receivedAt: Date.now()
  }
}
export function reactivateSubscription() {
  return dispatch => {
    dispatch(reactivateSubscriptionRequest())
    dispatch(cancelReactivateSubscriptionFormRequest())

    return ApiHelper.reactivateSubscription()
      .then(response => {
        if (response.status != 201) {
          dispatch(reactivateSubscriptionFailure())
          dispatch(cancelReactivateSubscriptionFormFailure(response.data))
        } else {
          dispatch(reactivateSubscriptionSuccess(response.data))
          dispatch(cancelReactivateSubscriptionFormSuccess())

          setTimeout(function() {
            // this.setState(this.initialState())
            // this.props.onCancelReactivateSubscriptionModalHide()

            dispatch({ type: "RESET_SUBS" }) //also closes modals
            dispatch(getInvoices())

            setTimeout(() => {
              dispatch(cancelReactivateSubscriptionFormReset())
            }, 1000)
          }, 2000)
        }
      })
      .catch(err => {
        dispatch(reactivateSubscriptionFailure())
        dispatch(cancelReactivateSubscriptionFormFailure(err.data))
      })
  }
}

export const CANCEL_SUBSCRIPTION_REQUEST = "CANCEL_SUBSCRIPTION_REQUEST"
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS"
export const CANCEL_SUBSCRIPTION_FAILURE = "CANCEL_SUBSCRIPTION_FAILURE"
export function cancelSubscriptionRequest() {
  return {
    type: CANCEL_SUBSCRIPTION_REQUEST
  }
}
function cancelSubscriptionSuccess(json) {
  return {
    type: CANCEL_SUBSCRIPTION_SUCCESS,
    subscription: json.subscription,
    receivedAt: Date.now()
  }
}
function cancelSubscriptionFailure() {
  return {
    type: CANCEL_SUBSCRIPTION_FAILURE,
    receivedAt: Date.now()
  }
}
export function cancelSubscription(password) {
  return dispatch => {
    dispatch(cancelSubscriptionRequest())
    dispatch(cancelReactivateSubscriptionFormRequest())

    return ApiHelper.cancelSubscription(password)
      .then(response => {
        if (response.status != 201) {
          dispatch(cancelSubscriptionFailure())
          dispatch(cancelReactivateSubscriptionFormFailure(response.data))
        } else {
          dispatch(cancelSubscriptionSuccess(response.data))
          dispatch(cancelReactivateSubscriptionFormSuccess())
          setTimeout(function() {
            // dispatch({ type: "CLOSE_SUB_MODAL" })
            dispatch({ type: "RESET_SUBS" })
            dispatch({ type: "OPEN_SURVEY_MODAL" })
            dispatch(getInvoices())

            setTimeout(() => {
              dispatch(cancelReactivateSubscriptionFormReset())
            }, 1000)
          }, 2000)
        }
      })
      .catch(err => {
        dispatch(cancelSubscriptionFailure())
        dispatch(cancelReactivateSubscriptionFormFailure(err.data))
      })
  }
}

export const CREATE_SUBSCRIPTION_REQUEST = "CREATE_SUBSCRIPTION_REQUEST"
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS"
export const CREATE_SUBSCRIPTION_FAILURE = "CREATE_SUBSCRIPTION_FAILURE"
export function createSubscriptionRequest() {
  return {
    type: CREATE_SUBSCRIPTION_REQUEST
  }
}
function createSubscriptionSuccess(json) {
  return {
    type: CREATE_SUBSCRIPTION_SUCCESS,
    subscription: json,
    receivedAt: Date.now()
  }
}
function createSubscriptionFailure() {
  return {
    type: CREATE_SUBSCRIPTION_FAILURE,
    receivedAt: Date.now()
  }
}
export function createSubscription(
  stripe_card_token,
  // product_identifier,
  coupon,
  quantity,
  sourceType,
  accountId
) {
  return (dispatch, getState) => {
    const { productIdentifier } = getState().subs

    dispatch(createSubscriptionRequest())
    dispatch(createSubscriptionFormRequest())
    //
    return ApiHelper.createSubscription(
      stripe_card_token,
      productIdentifier,
      coupon,
      quantity,
      sourceType,
      accountId
    )
      .then(response => {
        if (response.status != 201) {
          dispatch(createSubscriptionFailure())
          dispatch(createSubscriptionFormFailure(response.data))
        } else {
          dispatch(createSubscriptionSuccess(response.data))
          dispatch(createSubscriptionFormSuccess())

          dispatch({
            type: "SET_CURRENT_PLAN",
            product_identifier: response.data.product_identifier
          })

          dispatch(getInvoices())

          setTimeout(function() {
            dispatch({ type: "RESET_SUBS" })
            // this.props.onUpdateSubscriptionModalHide()
            // delay another second
            setTimeout(() => {
              dispatch(createSubscriptionFormReset())
              dispatch({ type: "SHOW_CREATE_SUB_SUCCESS_MODAL" })
            }, 1000)
          }, 2000)

          // NOTE: already done onCancel?
          // dispatch(hideCreateSubscriptionSuccessModal())
        }
      })
      .catch(err => {
        dispatch(createSubscriptionFailure())
        dispatch(createSubscriptionFormFailure(err.data))
      })
  }
}

export const CREATE_SUBSCRIPTION_FORM_REQUEST =
  "CREATE_SUBSCRIPTION_FORM_REQUEST"
export const CREATE_SUBSCRIPTION_FORM_FAILURE =
  "CREATE_SUBSCRIPTION_FORM_FAILURE"
export const CREATE_SUBSCRIPTION_FORM_SUCCESS =
  "CREATE_SUBSCRIPTION_FORM_SUCCESS"
export const CREATE_SUBSCRIPTION_FORM_RESET = "CREATE_SUBSCRIPTION_FORM_RESET"
export function createSubscriptionFormRequest() {
  return {
    type: CREATE_SUBSCRIPTION_FORM_REQUEST
  }
}
function createSubscriptionFormFailure(json) {
  return {
    type: CREATE_SUBSCRIPTION_FORM_FAILURE,
    json: json
  }
}
function createSubscriptionFormSuccess() {
  return {
    type: CREATE_SUBSCRIPTION_FORM_SUCCESS
  }
}
export function createSubscriptionFormReset() {
  return {
    type: CREATE_SUBSCRIPTION_FORM_RESET
  }
}

export const UPDATE_SUBSCRIPTION_FORM_REQUEST =
  "UPDATE_SUBSCRIPTION_FORM_REQUEST"
export const UPDATE_SUBSCRIPTION_FORM_FAILURE =
  "UPDATE_SUBSCRIPTION_FORM_FAILURE"
export const UPDATE_SUBSCRIPTION_FORM_SUCCESS =
  "UPDATE_SUBSCRIPTION_FORM_SUCCESS"
export const UPDATE_SUBSCRIPTION_FORM_RESET = "UPDATE_SUBSCRIPTION_FORM_RESET"
export function updateSubscriptionFormRequest() {
  return {
    type: UPDATE_SUBSCRIPTION_FORM_REQUEST
  }
}
function updateSubscriptionFormFailure(json) {
  return {
    type: UPDATE_SUBSCRIPTION_FORM_FAILURE,
    json: json
  }
}
function updateSubscriptionFormSuccess() {
  return {
    type: UPDATE_SUBSCRIPTION_FORM_SUCCESS
  }
}
export function updateSubscriptionFormReset() {
  return {
    type: UPDATE_SUBSCRIPTION_FORM_RESET
  }
}

export const UPDATE_SUBSCRIPTION_REQUEST = "UPDATE_SUBSCRIPTION_REQUEST"
export const UPDATE_SUBSCRIPTION_SUCCESS = "UPDATE_SUBSCRIPTION_SUCCESS"
export const UPDATE_SUBSCRIPTION_FAILURE = "UPDATE_SUBSCRIPTION_FAILURE"
export function updateSubscriptionRequest() {
  return {
    type: UPDATE_SUBSCRIPTION_REQUEST
  }
}
function updateSubscriptionSuccess(json) {
  return {
    type: UPDATE_SUBSCRIPTION_SUCCESS,
    subscription: json,
    receivedAt: Date.now()
  }
}
function updateSubscriptionFailure() {
  return {
    type: UPDATE_SUBSCRIPTION_FAILURE,
    receivedAt: Date.now()
  }
}
export function updateSubscription(product_identifier, coupon, quantity) {
  return dispatch => {
    dispatch(updateSubscriptionRequest())
    dispatch(updateSubscriptionFormRequest())

    return ApiHelper.updateSubscription(product_identifier, coupon, quantity)
      .then(response => {
        if (response.status != 201) {
          dispatch(updateSubscriptionFailure())
          dispatch(updateSubscriptionFormFailure(response.data))
        } else {
          dispatch(updateSubscriptionSuccess(response.data))
          dispatch(updateSubscriptionFormSuccess())
          dispatch(getInvoices())
          dispatch({
            type: "SET_CURRENT_PLAN",
            product_identifier: response.data.product_identifier
          })

          setTimeout(function() {
            // this.setState(this.initialState())
            dispatch({ type: "RESET_SUBS" })
            // this.props.onUpdateSubscriptionModalHide()
            // delay another second
            setTimeout(() => {
              dispatch(updateSubscriptionFormReset())
            }, 1000)
          }, 2000)
        }
      })
      .catch(err => {
        dispatch(updateSubscriptionFailure())
        dispatch(updateSubscriptionFormFailure(err.data))
      })
  }
}

export const UPDATE_CARD_FORM_REQUEST = "UPDATE_CARD_FORM_REQUEST"
export const UPDATE_CARD_FORM_FAILURE = "UPDATE_CARD_FORM_FAILURE"
export const UPDATE_CARD_FORM_SUCCESS = "UPDATE_CARD_FORM_SUCCESS"
export const UPDATE_CARD_FORM_RESET = "UPDATE_CARD_FORM_RESET"
export function updateCardFormRequest() {
  return {
    type: UPDATE_CARD_FORM_REQUEST
  }
}
function updateCardFormFailure(json) {
  return {
    type: UPDATE_CARD_FORM_FAILURE,
    json: json
  }
}
function updateCardFormSuccess() {
  return {
    type: UPDATE_CARD_FORM_SUCCESS
  }
}
export function updateCardFormReset() {
  return {
    type: UPDATE_CARD_FORM_RESET
  }
}

export const UPDATE_CARD_REQUEST = "UPDATE_CARD_REQUEST"
export const UPDATE_CARD_SUCCESS = "UPDATE_CARD_SUCCESS"
export const UPDATE_CARD_FAILURE = "UPDATE_CARD_FAILURE"
export function updateCardRequest() {
  return {
    type: UPDATE_CARD_REQUEST
  }
}
function updateCardSuccess(json) {
  return {
    type: UPDATE_CARD_SUCCESS,
    subscription: json.subscription,
    receivedAt: Date.now()
  }
}
function updateCardFailure() {
  return {
    type: UPDATE_CARD_FAILURE,
    receivedAt: Date.now()
  }
}
export function updateCard(
  stripe_card_token,
  // product_identifier,
  coupon,
  quantity,
  sourceType,
  accountId
) {
  return (dispatch, getState) => {
    // const { productIdentifier } = getState().subs
    const { product_identifier } = getState().models.user.subscription

    dispatch(updateCardRequest())
    dispatch(updateCardFormRequest())

    return ApiHelper.updateCard(
      stripe_card_token,
      product_identifier,
      coupon,
      quantity,
      sourceType,
      accountId
    )
      .then(response => {
        if (response.status != 201) {
          dispatch(updateCardFailure())
          dispatch(updateCardFormFailure(response.data))
        } else {
          dispatch(updateCardSuccess(response.data))
          dispatch(updateCardFormSuccess())
          setTimeout(function() {
            // this.setState(this.initialState())
            dispatch({ type: "RESET_SUBS" })
            // remove checkmark from btn and reset form params
            // this.props.onUpdateCardModalHide()
            dispatch(updateCardFormReset())
          }, 2000)
        }
      })
      .catch(err => {
        dispatch(updateCardFailure())
        dispatch(updateCardFormFailure(err.data))
      })
  }
}

const queryString = require("query-string")

export function selectPlanFromUrl() {
  return (dispatch, getState) => {
    const {
      subs,
      models: { plans },
      router: { location }
    } = getState()
    const parsed = queryString.parse(location.search)

    if (subs.isFetchingPlans)
      return setTimeout(() => dispatch(selectPlanFromUrl()), 1000)

    let plan = null

    if (parsed.plan && plans.length == 1) {
      plan = plans[0]
    }
    // if more than one, match the interval
    else if (parsed.plan == "monthly") {
      plan = plans.find(plan => plan.interval == "month")
    } else if (parsed.plan == "yearly" || parsed.plan == "annual") {
      plan = plans.find(plan => plan.interval == "year")
    }
    return plan && dispatch(selectPlan(plan.id))
  }
}

export function getPlans() {
  return dispatch => {
    dispatch({ type: "GET_PLANS_REQUEST" })

    return ApiHelper.getPlans().then(
      ({ data }) => {
        dispatch({ type: "GET_PLANS_SUCCESS", data })
      },
      error => {
        dispatch({ type: "GET_PLANS_FAIL" })
      }
    )
  }
}

export function getInvoices() {
  return dispatch => {
    dispatch({ type: "GET_INVOICES_REQUEST" })

    return ApiHelper.getInvoices().then(
      ({ data }) => {
        dispatch({ type: "GET_INVOICES_SUCCESS", data })
      },
      error => {
        dispatch({ type: "GET_INVOICES_FAIL" })
      }
    )
  }
}

export function loadMoreInvoices() {
  return (dispatch, getState) => {
    const { invoices } = getState().models
    const lastInvoice = invoices[invoices.length - 1]
    const starting_after = lastInvoice.id
    // dispatch(getInvoices(starting_after))
    dispatch({ type: "GET_MORE_INVOICES_REQUEST", starting_after })

    return ApiHelper.getInvoices(starting_after).then(
      ({ data }) => {
        dispatch({ type: "GET_MORE_INVOICES_SUCCESS", data })
      },
      error => {
        dispatch({ type: "GET_MORE_INVOICES_FAIL" })
      }
    )
  }
}

export function selectPlan(
  productIdentifier
  // total,
  // interval,
  // trial_period_days
) {
  return (dispatch, getState) => {
    const { hasSubscription } = getState().models.user
    const { plans } = getState().models

    const modalType = hasSubscription
      ? "showUpdateSubscriptionModal"
      : "showStripeModal"

    const plan = plans.find(plan => plan.id == productIdentifier)

    dispatch({
      type: "SELECT_PLAN",
      plan: {
        productIdentifier: plan.id,
        total: plan.amount / 100,
        interval: plan.interval,
        trial_period_days: plan.trial_period_days,
        [modalType]: true
      }
    })
  }
}

export function onCancelReactivateSubscriptionSubmit(password) {
  return (dispatch, getState) => {
    const { subscription } = getState().models.user
    if (subscription.customer.cancel_at_period_end) {
      dispatch(reactivateSubscription())
    } else {
      dispatch(cancelSubscription(password))
    }
  }
}

// triggered from "Reactivate" or "Cancel" buttons:
export function handleCancelReactivateClick() {
  return (dispatch, getState) => {
    const { subscription } = getState().models.user

    const reactivating = subscription.customer.cancel_at_period_end
    dispatch({ type: "CANCEL_REACTIVATE", reactivating })
  }
}

export function closeSubModal() {
  return {
    // type: "CLOSE_STRIPE_MODAL"
    type: "CLOSE_SUB_MODAL"
  }
}



// WEBPACK FOOTER //
// ./src/subscriptions/actions.js